import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { NgClass } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

/** Mismo mapa que en `custom-message`, para que un 'error' se vea igual
 *  en el diálogo y en la barrita de abajo. */
const ICONOS: Record<string, string> = {
  success: 'check_circle',
  error:   'error',
  warning: 'warning',
  neutral: 'info',
};

const TIPO_POR_DEFECTO = 'neutral';

@Component({
  selector: 'app-custom-snack-bar',
  standalone: true,
  imports: [NgClass, MatIconModule, MatButtonModule],
  templateUrl: './custom-snack-bar.component.html',
  styleUrls: ['./custom-snack-bar.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CustomSnackBarComponent {

  constructor(
    private snackBarRef: MatSnackBarRef<CustomSnackBarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; type: string }
  ) {}

  /**
   * El icono era `<img src="{{data.type}}.gif">`: los .gif no existen en el
   * proyecto y además la ruta era relativa, así que en `/users` pedía
   * `/users.gif`. Ver la nota larga en `custom-message.component.ts`.
   */
  tipo(): string {
    const t = (this.data.type ?? '').toLowerCase();
    return t in ICONOS ? t : TIPO_POR_DEFECTO;
  }

  icono(): string {
    return ICONOS[this.tipo()];
  }

  public close(): void {
    this.snackBarRef.dismiss();
  }
}